import Get from '../helpers/Get';
import URL from '../helpers/URL';
import Ajax from '../helpers/Ajax';

;$(function() {
	$('input.number').number(true, 0, ',', ' ');

	function clearExtendedInputs(form) {
		$(form).find('.filter__item_extended').each(function() {
			$(this).find('.custom-select__option_selected').removeClass('custom-select__option_selected');
			$(this).find('input, select').val('');
			$(this).find('.custom-select__button[data-default-text]').each(function() {
				$(this).find('.custom-select__caption').html($(this).data('default-text'));
				$(this).removeAttr('data-default-text');
			});
		});
	};

	$(document).on('click', '.filter-button[data-type=open-extended-search]', function() {
		if (($(this).hasClass('filter-button_extended')) && ($(this).data('extend-text')) && ($(this).data('simple-text'))) {
			$(this).find('.filter-button__caption').html($(this).data('extend-text'));
		} else {
			$(this).find('.filter-button__caption').html($(this).data('simple-text'));
		}

		if (($(this).hasClass('filter-button_extended')) && ($(this).data('extend-icon')) && ($(this).data('simple-icon'))) {
			$(this).find('img.filter-button__icon').attr('src', $(this).data('extend-icon'));
		} else {
			$(this).find('img.filter-button__icon').attr('src', $(this).data('simple-icon'));
		}

		if ($(this).hasClass('filter-button_extended')) {
			clearExtendedInputs($(this).parents('.filter__form'));
		}

		$(this).toggleClass('filter-button_extended');
		$(this).parents('.filter').toggleClass('filter_extended');
	});

	function quickFilter() {
		var targetClass = $(this).data('target-class');
		var targetSelector = '.' + targetClass;
		var cardList = $(this).parents('.card-list');

		$(this).parents('.quick-filter').find('[data-type="quick-filter"]').each(function() {
			var targetTag = $(this).val();
			var filterField = $(this).data('filter');
			if (targetTag) {
				targetSelector += '[data-' + filterField + '~=' + targetTag + ']';
			}
		});
		cardList.find('.' + targetClass).addClass(targetClass + '_hidden');
		cardList.find(targetSelector).removeClass(targetClass + '_hidden');

		if (cardList.hasClass('map-wrapper')) {
			cardList.find('.' + targetClass).find('[data-type="address"]').each(function() {
				if ($(this).data('placemark')) {
					cardList.find('.map').data('map').geoObjects.remove($(this).data('placemark'));
				}
			});
			cardList.find(targetSelector).find('[data-type="address"]').each(function() {
				if ($(this).data('placemark')) {
					cardList.find('.map').data('map').geoObjects.add($(this).data('placemark'));
				}
			});
		}
	}

	$('.custom-select__multi-option[data-group="brand"]').click(function() {
		let _ 		= $(this);
		let id 		= _.attr('data-value');
		let name 	= _.text();
		let form 	= _.parents('form').eq(0);

		if (_.hasClass('custom-select__multi-option_selected')) {
			let div = _.parents('.filter__item').next().children('.custom-select__wrapper');

			div.find('.custom-select__multi-option_selected[data-group="model[' + id + ']"]').click();

			div.find('[data-brand-group="' + id + '"]').remove();
			return;
		}

		$.ajax({
			type: 'POST',
			url: '/api/filter/models',
			data: {
				brand: id,
				auction: Helper.auction,
			},
			success: html => {
				let select = _.parents('.filter__item').next().children('.custom-select__wrapper');

				if (! select.children('div.custom-select__list').length)
					select.children('.custom-select__list').after('<div class="custom-select__list custom-select__list_multi"></div>').remove();

				select.children('.custom-select__list').append(html);

				if (! select.children('.custom-select__list').children('.custom-select__list-close').length) {
					select.children('.custom-select__list').append('<div class="custom-select__list-close">Свернуть</div>');
				}
			}
		})
	});

	$('[data-group="brand"][data-value=""]').click(function() {
		if (! $(this).parents('.filter__item').next().find('div.custom-select__list').length)
			return;

		$(this).parents('.filter__item').next().find('.custom-select__multi-option_selected').trigger('click');

		$(this).parents('.filter__item').next().find('div.custom-select__list').after('<ul class="custom-select__list custom-select__list_multi"><li class="custom-select__item"><button class="custom-select__option custom-select__option_selected" type="button" data-group="model" data-value="" data-url="">Все</button></li></ul>').remove();
	});

	$('#result-count').click(() => $('.filter-button[type="submit"]').trigger('click'));
	$('.filter-button[type="submit"]').click(function(e) {
		e.preventDefault();

		var form = $(this).parents('form').eq(0);

		let Filter = Get.parse('?' + form.serialize());

		for (var i in Filter)
			if (Filter[i] == '')
				delete Filter[i];

		if (Filter.model)
			for (var i in Filter.model)
				if (typeof Filter.model[i] == 'string')
					Filter.model[i] = [Filter.model[i]];

		var newUrl = URL.path;

		if (Object.keys(Filter).length) {
			let q = [];
			for (let i in Filter) {
				switch (i) {
					case 'brand':
						for (var b in Filter.brand)
							q.push(encodeURIComponent('brand[]') + '=' + encodeURIComponent(Filter.brand[b]));

						break;

					case 'model':
						for (var b in Filter.model)
							for (var m in Filter.model[b])
								q.push(encodeURIComponent('model[' + b + '][]') + '=' + encodeURIComponent(Filter.model[b][m]));

						break;

					default:
						if (typeof Filter[i] === 'array' || typeof Filter[i] === 'object') {
							for (var j in Filter[i])
								q.push(encodeURIComponent(i + '[]') + '=' + encodeURIComponent(Filter[i][j]));
						} else {
							q.push(encodeURIComponent(i) + '=' + encodeURIComponent(Filter[i]));
						}
						break;
				}
			}

			if (q.length)
				newUrl += '?' + q.join('&');
		}

		window.location.href = newUrl;
	});

	$('.filter-tag__item').click(function() {
		let form = $(this).parent().siblings('form');
		let key = $(this).data('key');
		let val = $(this).data('val');

		if (key.indexOf('min_') > -1 || key.indexOf('max_') > -1) {
			form.find('input[name="' + key + '"]')[0].value = '';
		} else if (key == 'stock') {
			if (form.find('input[name="stock"]').length && form.find('input[name="stock"]').val() != '')
				form.find('input[name="stock"]').remove();
			else {
				let auctionRoute = '/';
				let brandRoute = URL.route.length > 1 ? '/' + URL.route[1] : '';
				let modelRoute = URL.route.length > 2 ? '/' + URL.route[2] : '';
				let query = '/' + URL.search;
				window.location.href = auctionRoute + brandRoute + modelRoute + query;
				return;
			}
		} else {
			form.find('[data-group="' + key + '"][data-value="' + val + '"]').trigger('click');
			form.find('input[name="' + key + '[]"][value="' + val + '"]').remove();
		}

		form.find('.filter-button[type="submit"]').trigger('click');
	});

	$('[data-type="quick-filter"').change(quickFilter);
	quickFilter.apply($('[data-type="quick-filter"').get(0));
});

;$(function() {

	var page = {};
	page.input 	= $('.filter__input');

	page.input.bind('input', Ajax.filter.count);

});